import script from "./Heart.vue?vue&type=script&setup=true&lang=js"
export * from "./Heart.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__